<ion-list class="lang-list-box">
  <ion-radio-group *ngFor="let service of inputs;let i = index;" allow-empty-selection [value]="service.groupVal">
    <!-- <ion-item (ionSelect)="selectService(service.value)" (ionFocus)="focuns()" (ionBlur)="blur()"> -->
    <ion-item>
      <ion-icon name="person"></ion-icon>
      <ion-label>{{service.name}}</ion-label>
      <ion-radio [value]="service.value" (ionFocus)="focus($event)"></ion-radio>
    </ion-item>

  </ion-radio-group>
</ion-list>